module.exports = __webpack_public_path__ + "media/images/AddButton-de62df6a.svg";